import { SxProps, Theme } from "@mui/material";

const getStyles = (theme: Theme): Record<string, Record<string, SxProps<Theme>>> => ({
  ClassInformation: {
    alert: {
      position: "relative",
      mb: "var(--rhythm)",
      ".MuiAlert-message": {
        width: "100%",
      },
      ".MuiIconButton-root": {
        position: "absolute",
        top: "8px",
        right: "8px",
      },
      [theme.breakpoints.down("md")]: {
        marginX: "calc(-1 * var(--rhythm))",
        borderLeft: "none",
        borderRight: "none",
        borderRadius: 0,
        ".MuiIconButton-root": {
          display: "none",
        },
      },
    },
    text: {
      color: "var(--color-black)",
    },
    link: {
      fontWeight: "bold",
      textDecoration: "underline",
      color: "var(--color-blue)",
      cursor: "pointer",
    },
    close: {
      display: "none",
      [theme.breakpoints.down("md")]: {
        display: "flex",
      },
    },
  },

  ClassOptions: {},

  BorderClasses: {
    container: {
      display: "flex",
      flexDirection: "column",
      p: "calc(2 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        p: "var(--rhythm)",
      },
    },

    title: {
      mb: "calc(1.5 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        mb: "var(--rhythm)",
      },
    },

    subtitle: {
      mt: "calc(-1 * var(--rhythm))",
      mb: "calc(1.8 * var(--rhythm))",
    },

    classes: {
      flexDirection: "column",
      gap: "calc(2 * var(--rhythm))",
      width: "100%",
      [theme.breakpoints.down("md")]: {
        gap: "var(--rhythm)",
      },
    },

    custom: {
      mt: "calc(1.5 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        mt: "var(--rhythm)",
      },
    },

    actions: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      width: "100%",
      mt: "calc(2 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        justifyContent: "center",
        mt: "var(--rhythm)",
      },
    },
  },
});

export default getStyles;
